import { Injectable } from '@angular/core';

import { Equipment, Fai, PRICE_TYPES, Product, ProductFactory, PromotionsModel } from '@bytel/bytel-sales';

import { PriceCouponPipe } from '@shared/pipes/price-coupon.pipe';
import { PriceFinalEquipmentPipe } from '@shared/pipes/price-final-equipment.pipe';
import { PriceWithoutCouponPipe } from '@shared/pipes/price-without-coupon.pipe';

@Injectable({
    providedIn: 'root',
})
export class TicketPricesFactory {
    public static GetPrice(product: Product, qty: number = 1): number {
        let finalPrice;
        if (product.priceType === PRICE_TYPES.Today) {
            const equipmentPricepipe = new PriceFinalEquipmentPipe();
            finalPrice = equipmentPricepipe.transform(product as Equipment, false) * qty;
        } else {
            const pipe = new PriceWithoutCouponPipe();
            finalPrice = pipe.transform(product);
        }

        if (ProductFactory.Is(product, Fai, false)) {
            finalPrice += (product as Fai).data.rental_fees;
        }

        return finalPrice;
    }

    public static GetCouponPrice(product: Product): number {
        const pipe = new PriceCouponPipe();
        const initialPrice = product.prices.final;
        const priceWithoutCoupon = pipe.transform(product);
        return initialPrice - priceWithoutCoupon;
    }

    public static GetDurationPrice(product: Product): number {
        let price = product.prices.base;

        price -= product.promotions.automatic
            .filter((promo) => promo.duration === 0)
            .reduce((acc, promotion) => acc + promotion.reductionAmount, 0);

        if (ProductFactory.Is(product, Fai, false)) {
            price += (product as Fai).data.rental_fees;
        }
        return Math.max(product.minPromoPrice, PromotionsModel.roundPrice(price));
    }
}
